'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { httpBatchLink } from '@trpc/client'
import React, { useState } from 'react'
import superjson from 'superjson'
import { trpcReact } from './trpcReact'

async function getAuthCookie() {
    const cookieStr = document.cookie
    const cookies = cookieStr.split(';').reduce<Record<string, string>>((acc, cookie) => {
        const [key, value] = cookie.trim().split('=')
        if (key && value) {
            acc[key] = value
        }
        return acc
    }, {})

    return cookies['__session'] || ''
}

export function TRPCProvider({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        retry: false,
                        refetchOnWindowFocus: false,
                        staleTime: 0.1 * 60 * 1000, // 0.1 minutes
                        gcTime: 0.5 * 60 * 1000, // 0.5 minutes
                    },
                    mutations: {
                        retry: false,
                        // Add mutation caching
                        mutationKey: ['users.getOrCreate'],
                        gcTime: 1000 * 60 * 1, // 6 seconds
                    },
                },
            })
    )

    const [trpcClient] = useState(() =>
        trpcReact.createClient({
            links: [
                httpBatchLink({
                    url: '/api/trpc',
                    transformer: superjson,
                    headers: async () => {
                        const auth = await getAuthCookie()
                        return {
                            authorization: auth,
                            'Content-Type': 'application/json',
                        }
                    },
                }),
            ],
        })
    )

    return (
        <trpcReact.Provider client={trpcClient} queryClient={queryClient}>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </trpcReact.Provider>
    )
}
